export enum HeaderType {
    TABLE = 0,
    SUB_GRADE = 1,
    DEFECTS = 2,
    DEFECT_SUMMARY = 3,
    SHARED_DEFECTS = 4,
}